import store from '@/store';
import { DASHBOARD_ROUTE } from '@/router/routes';
import { CLEAR_ERRORMSG } from '@/store/action_types';
import { RouteLocationNormalized } from 'vue-router';
import { isAdminRole } from '@/utils/roles';

export const ifNotAdminDeny = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: Function
) => {
  store.dispatch(CLEAR_ERRORMSG);

  const role = store.getters.account.data?.role;

  if (isAdminRole(role)) {
    next();
  } else {
    if (to.name === DASHBOARD_ROUTE) {
      next();
    } else {
      next({ name: DASHBOARD_ROUTE });
    }
  }
};
